import * as tslib_1 from "tslib";
import { JobMatchQueryFilter } from "../../../../../models/jobMatchQueryFilter";
import { OverrideNoteDetail } from "../../../../../models/overrideNoteDetail";
import { JobMatchAction } from "../../../../../models/jobMatchAction";
import { MatchedCandidatesContainer } from "./matched-candidates-infinite-scroll-container";
import { AssociateCandidateQueryFilter } from "src/app/public/app/models/associateCandidatesQueryFilter";
import { AssociateCandidateDisplayQueryFilter } from "src/app/public/app/models/associateCandidateDisplayQueryFilter";
import * as AssociatesCandidateActionsModalTemplate from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/associateCandidates/associate-candidates-action-modal.html';
import * as CandidateSendOutreachEmailModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/candidateJobMatchCard/candidate-send-outreach-email-modal.html';
var AssociateCandidatesController = /** @class */ (function () {
    /*@ngInject*/
    function AssociateCandidatesController($rootScope, $scope, $timeout, $uibModal, $filter, jobService, jobMatchActionsService, candidateService, jobMatchService, companyService, genericService, modalService, debounceService, alertsAndNotificationsService, requisitionService, MESSAGECONSTANTS) {
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$uibModal = $uibModal;
        this.$filter = $filter;
        this.jobService = jobService;
        this.jobMatchActionsService = jobMatchActionsService;
        this.candidateService = candidateService;
        this.jobMatchService = jobMatchService;
        this.companyService = companyService;
        this.genericService = genericService;
        this.modalService = modalService;
        this.debounceService = debounceService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.requisitionService = requisitionService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
    }
    AssociateCandidatesController.prototype.$onInit = function () {
        var _this = this;
        this.isLoading = true;
        //variables
        this._initVariables();
        this.getSalaryDurationOptions();
        this.getCurrencyCodes();
        this.getJobDetails(function () {
            _this.getAllWorkLocations(function () {
                _this.getAllWorkAuthorizations(function () {
                    _this.getAllPreferredJobTypes(function () {
                        _this.getAllAdditionalPreferredJobTypes(function () {
                            _this.associateCandidatesDefaultFilter = new AssociateCandidateQueryFilter();
                            _this._setAllAssociatedCandidatesFilters(_this.associateCandidatesDefaultFilter);
                            _this.associateCandidatesDefaultFilterCopy = _.cloneDeep(_this.associateCandidatesDefaultFilter);
                            _this.matchedCandidatesContainer = new MatchedCandidatesContainer(_this.$rootScope.userDetails.id, _this.$rootScope.userDetails.company.companyId, _this.jobId, _this.associateCandidatesDefaultFilter, _this.jobDetails, _this.defaultPageSize, _this.jobMatchService, _this.jobService, _this.candidateService, _this.alertsAndNotificationsService);
                            _this.createJobMatchesObject = {
                                companyId: _this.$rootScope.userDetails.company.companyId,
                                requisitionId: _this.jobId,
                                candidateIds: [],
                                isAddCandidate: false,
                                isAssociateCandidate: true,
                                overrideNoteDetails: []
                            };
                            _this._setQueryFilter();
                            _this.sortRequisitions('Score Desc', 'Score', 'Desc');
                            _this._createMatchScoreSlider();
                            _this.isFiltersChanged = false;
                            _this.isLoading = false;
                        });
                    });
                });
            });
            _this._setDisplayFilter();
            _this._setResumeOptions();
            _this.searchCandidates = _.debounce(_this.searchCandidates, 500);
        });
        this._checkIfOutreachEnabled();
    };
    AssociateCandidatesController.prototype._setDisplayFilter = function () {
        this.displayAssociateCandidateSelectedFilter = new AssociateCandidateDisplayQueryFilter();
        this.showCandidateDisplaySelectedFilterPanel = this.displayAssociateCandidateSelectedFilter.showCandidateDisplayFilterIcon;
    };
    AssociateCandidatesController.prototype._setQueryFilter = function () {
        var _this = this;
        $(document).ready(function () {
            _this.isFilterOpen = true;
            $("#associate-search-panel").animate({
                height: 'toggle'
            });
            $(document).off("click", "#open-associate-filter").on("click", "#open-associate-filter", function () {
                $("#associate-search-panel").animate({
                    height: 'toggle'
                });
                _this.isFilterOpen = !_this.isFilterOpen;
            });
        });
    };
    AssociateCandidatesController.prototype.searchCandidates = function () {
        this.searchForMatchingCandidates();
    };
    AssociateCandidatesController.prototype._initVariables = function () {
        this.jobDetails;
        this.associateCandidatesDefaultFilter = {};
        this.associateCandidatesDefaultFilterCopy = {};
        this.matchedCandidatesContainer = null;
        this.createJobMatchesObject = null;
        this.minimumScoreSliderPadding = 0;
        this.maximumScoreSliderPadding = 100;
        this.maximumScoreSliderTopPosition = 0;
        this.defaultPageSize = 18;
        this.warningModal;
        this.lastModifiedOptions = [
            { text: 'Any Time', value: 0 },
            { text: '1 day', value: 1 },
            { text: '2 days', value: 2 },
            { text: '3 days', value: 3 },
            { text: '1 week', value: 7 },
            { text: '2 weeks', value: 14 },
            { text: '1 month', value: 30 },
            { text: '3 months', value: 90 },
            { text: '6 months', value: 180 },
            { text: '1 year', value: 365 }
        ];
        this.topMatchesOptions = [
            { text: 'All', value: 0 },
            { text: '5', value: 5 },
            { text: '10', value: 10 },
            { text: '25', value: 25 },
            { text: '50', value: 50 },
            { text: '75', value: 75 },
            { text: '100', value: 100 },
            { text: '200', value: 200 }
        ];
        this.clientOrBuLabel = 'Client';
        this.workLocations = [];
        this.workAuthorizationList = [];
        this.jobTypeList = [];
        this.jobTypeAdditionalList = [];
        this.selectedWorkLocations = [];
        this.selectedJobTypeList = [];
        this.selectedJobTypeAdditionalList = [];
        this.selectedWorkAuthorizationList = [];
        this.filterSalaryDurationOptions = [];
        this.filterRateDurationOptions = [];
        this.selectedSort = "Please Select";
        this.candidateFilterItemsSelected = [];
        // flags
        this.savingFlag = false;
        this.selectAllCandidatesFlag = false;
        this.isAssociateCandidateForCorp = false;
        this.isUploadResumeOnlyEnabled = false;
        this.loadingJobTypeFilter = true;
        this.loadingAdditionalJobTypeFilter = true;
        this.loadingWorkAuthorizationFilter = true;
        this.isPreferredJobTypeFullTime = false;
        this.isPreferredJobTypeNotFullTime = false;
        this.isFilterOpen = false;
        this.emptyCandidateSelectedFilter = false;
        this.isDisplayRateFilterActive = false;
        this.isOutreachEnabled = false;
        this.noAdditionalDetails = true;
        this.isClearClicked = false;
        if (this.$rootScope.userDetails.company.companyType === this.MESSAGECONSTANTS.COMPANY_TYPES.CORPORATE) {
            this.clientOrBuLabel = 'BU';
        }
        this.isAssociateCandidateForCorp = this.companyService.isCorporateCompany() || (!_.isUndefined(this.corporateId) && this.corporateId !== "");
    };
    AssociateCandidatesController.prototype.getJobDetails = function (successCallback) {
        var _this = this;
        this.jobService.getJobProfile(this.jobId, function (data) {
            _this.jobDetails = data;
            _this.jobDetails.jobSalaryDto = _this.jobDetails.jobSalary;
            // this.noAdditionalDetails = this.jobDetails.includeCandidatesWithNoAdditionalDetails;
            _this._massageRequisitionCardInfo(_this.jobDetails);
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    AssociateCandidatesController.prototype.getAllWorkLocations = function (successCallback) {
        var _this = this;
        this.jobService.getWorkLocations(function (data) {
            _this.workLocations = data;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    AssociateCandidatesController.prototype.getSalaryDurationOptions = function () {
        var _this = this;
        this.jobService.getSalaryDurationOptions(function (data) {
            _this.salaryDurationOptions = data;
            var tempSalaryDurationOptions = _.cloneDeep(data);
            tempSalaryDurationOptions.map(function (duration) {
                duration.name = duration.name.slice(4);
            });
            _this.filterSalaryDurationOptions = tempSalaryDurationOptions.filter(function (salaryDuration) { return salaryDuration.value === 'PER_YEAR'; });
            _this.filterRateDurationOptions = tempSalaryDurationOptions.filter(function (salaryDuration) { return salaryDuration.value != 'PER_YEAR'; });
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    AssociateCandidatesController.prototype.getAllPreferredJobTypes = function (successCallback) {
        var _this = this;
        this.loadingJobTypeFilter = true;
        this.jobService.getAllJobTypes(function (data) {
            _this.jobTypeList = data;
            _this.jobTypeList.push({ name: "No Pref. Job Type", value: "NO_PREF_JOBTYPE" });
            if (successCallback) {
                successCallback();
            }
            _this.loadingJobTypeFilter = false;
        }, function (error) {
            _this.loadingJobTypeFilter = false;
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    AssociateCandidatesController.prototype.getAllAdditionalPreferredJobTypes = function (successCallback) {
        var _this = this;
        this.loadingAdditionalJobTypeFilter = true;
        this.jobService.getAllJobSubTypes(function (data) {
            _this.jobTypeAdditionalList = data;
            _this.jobTypeAdditionalList.push({ name: 'Not Specified', value: 'NO_PREF_JOBSUBTYPE' });
            if (successCallback) {
                successCallback();
            }
            _this.loadingAdditionalJobTypeFilter = false;
        }, function (error) {
            _this.loadingAdditionalJobTypeFilter = false;
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    AssociateCandidatesController.prototype.getAllWorkAuthorizations = function (successCallback) {
        var _this = this;
        this.loadingWorkAuthorizationFilter = true;
        this.jobService.getAllSponsorshipTypes(function (data) {
            _this.workAuthorizationList = data;
            _this.jobDetails.sponsorshipsTextList = [];
            if (_this.jobDetails.sponsorships && _this.jobDetails.sponsorships.length > 0) {
                _this.jobDetails.sponsorshipsTextList = _this.workAuthorizationList
                    .filter(function (val) { return _this.jobDetails.sponsorships.includes(val.value); })
                    .map(function (val) { return val.name; });
            }
            if (successCallback) {
                successCallback();
            }
            _this.loadingWorkAuthorizationFilter = false;
        }, function (error) {
            _this.loadingWorkAuthorizationFilter = false;
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    AssociateCandidatesController.prototype.getCurrencyCodes = function () {
        var _this = this;
        this.jobService.getCurrencyCodes(function (data) {
            _this.currencyCodes = data;
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    AssociateCandidatesController.prototype._massageRequisitionCardInfo = function (data) {
        var massagedRequisitionInfo = this.requisitionService.massageRequisitionCardInfo(data, this.salaryDurationOptions);
        angular.merge(this.jobDetails, massagedRequisitionInfo.data);
    };
    AssociateCandidatesController.prototype._checkIfOutreachEnabled = function () {
        // this.candidateService.getOutreachEmailEnabledStatus((data) => {
        //     this.isOutreachEnabled = data;
        // }, (error) => {
        //     this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        // });
        this.isOutreachEnabled = true;
    };
    AssociateCandidatesController.prototype._setAllAssociatedCandidatesFilters = function (associateCandidatesDefaultFilter) {
        var _this = this;
        if (this.jobDetails.workLocations && this.jobDetails.workLocations.length > 0) {
            this._setWorkLocations();
            associateCandidatesDefaultFilter.workLocationIds = this.jobDetails.workLocations.map(function (workLocation) { return workLocation.id; });
            if (this.noAdditionalDetails) {
                associateCandidatesDefaultFilter.workLocationIds.push('NO_WORK_LOCATION');
            }
        }
        if (this.jobDetails.jobType && this.jobDetails.jobType != "") {
            this._setPreferredJobType();
            associateCandidatesDefaultFilter.jobTypes.push(this.jobTypeList.filter(function (jobType) { return jobType.name === _this.jobDetails.jobType; })[0].value);
            if (this.noAdditionalDetails) {
                associateCandidatesDefaultFilter.jobTypes.push('NO_PREF_JOBTYPE');
            }
        }
        if (this.jobDetails.sponsorships && this.jobDetails.sponsorships.length > 0) {
            this._setWorkAuthorizations();
            associateCandidatesDefaultFilter.sponsorships = this.jobDetails.sponsorships;
            if (this.noAdditionalDetails) {
                associateCandidatesDefaultFilter.sponsorships.push('NO_WORK_AUTHORIZATION_SPECIFIED');
            }
        }
        this._setSalaryOrRate(associateCandidatesDefaultFilter);
        associateCandidatesDefaultFilter.includeCandidatesWithNoAdditionalDetails = this.noAdditionalDetails;
    };
    AssociateCandidatesController.prototype._setWorkLocations = function () {
        var _this = this;
        this.selectedWorkLocations = this.workLocations.filter(function (workLocation) { return _this.jobDetails.workLocations.some(function (value) { return workLocation.id === value.id; }); });
        if (this.noAdditionalDetails) {
            this.workLocations.forEach(function (workLocation) {
                if (workLocation.name == 'No Work Location') {
                    workLocation.ticked = true;
                }
            });
            var noWorkLocation = this.workLocations.filter(function (workLocation) { return _this.jobDetails.workLocations.some(function (value) { return workLocation.name === 'No Work Location'; }); });
            this.selectedWorkLocations = noWorkLocation ? tslib_1.__spread(this.selectedWorkLocations, noWorkLocation) : this.selectedWorkLocations;
        }
        this.selectedWorkLocations.forEach(function (work) { return work.ticked = true; });
        this._setAssociateCandidateDisplayFilters('workLocations');
    };
    AssociateCandidatesController.prototype._setAssociateCandidateDisplayFilters = function (type) {
        this.isFiltersChanged = true;
        switch (type) {
            case 'workLocations':
                this.displayAssociateCandidateSelectedFilter.workLocationIds = this.selectedWorkLocations.map(function (val, index) {
                    return val.name;
                });
                break;
            case 'sponsorships':
                this.displayAssociateCandidateSelectedFilter.sponsorships = this.selectedWorkAuthorizationList.map(function (val, index) {
                    return val.name;
                });
                break;
            case 'jobTypes':
                this.displayAssociateCandidateSelectedFilter.jobTypes = this.selectedJobTypeList.map(function (val, index) {
                    return val.name;
                });
                break;
            case 'jobSubTypes':
                this.displayAssociateCandidateSelectedFilter.jobSubTypes = this.selectedJobTypeAdditionalList.map(function (val, index) {
                    return val.name;
                });
                break;
            case 'salary':
                this.displayAssociateCandidateSelectedFilter.salary = this._setSalaryAndRateDisplayFilter('salary');
                break;
            case 'rate':
                this.displayAssociateCandidateSelectedFilter.rate = this._setSalaryAndRateDisplayFilter('rate');
                this.isDisplayRateFilterActive = true;
                break;
            default:
            // Do Nothing
        }
        this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
    };
    AssociateCandidatesController.prototype._setJobMatchScoreDisplayFilter = function (minScore, maxScore) {
        var score = "";
        if (minScore === this.jobDetails.fourDotFiveIntelligenceScore && maxScore === 100) {
            score = "";
        }
        else {
            score = "From " + minScore + " To " + maxScore;
        }
        return score;
    };
    AssociateCandidatesController.prototype.onWorkLocationSelected = function () {
        this.isFiltersChanged = true;
        this.matchedCandidatesContainer.searchObject.workLocationIds = this.selectedWorkLocations.map(function (location) { return location.id; });
        this._setAssociateCandidateDisplayFilters('workLocations');
    };
    AssociateCandidatesController.prototype.onJobTypeSelected = function () {
        this.isFiltersChanged = true;
        this.matchedCandidatesContainer.searchObject.jobTypes = this.selectedJobTypeList.map(function (val, index) {
            return val.value;
        });
        this.displayAssociateCandidateSelectedFilter.salary = this._setSalaryAndRateDisplayFilter('salary');
        this.displayAssociateCandidateSelectedFilter.rate = this._setSalaryAndRateDisplayFilter('rate');
        this._setAssociateCandidateDisplayFilters('jobTypes');
    };
    AssociateCandidatesController.prototype.onAdditionalJobTypeSelected = function () {
        this.isFiltersChanged = true;
        this.matchedCandidatesContainer.searchObject.jobSubTypes = this.selectedJobTypeAdditionalList.map(function (val, index) {
            return val.value;
        });
        this._setAssociateCandidateDisplayFilters('jobSubTypes');
    };
    AssociateCandidatesController.prototype.onWorkAuthorizationSelected = function () {
        this.isFiltersChanged = true;
        this.matchedCandidatesContainer.searchObject.sponsorships = this.selectedWorkAuthorizationList.map(function (val, index) {
            return val.value;
        });
        this._setAssociateCandidateDisplayFilters('sponsorships');
    };
    AssociateCandidatesController.prototype.onSalaryDurationChange = function () {
        if (this.matchedCandidatesContainer.searchObject.salaryDuration) {
            this._setAssociateCandidateDisplayFilters('salary');
        }
    };
    AssociateCandidatesController.prototype.onRateDurationChange = function () {
        if (this.matchedCandidatesContainer.searchObject.rateDuration) {
            this._setAssociateCandidateDisplayFilters('rate');
        }
    };
    AssociateCandidatesController.prototype.onSalaryOrRateCurrencyChange = function (type) {
        this.isFiltersChanged = true;
        if (this.displayAssociateCandidateSelectedFilter.rate != "" || this.displayAssociateCandidateSelectedFilter.salary != "") {
            this.displayAssociateCandidateSelectedFilter.salary = this._setSalaryAndRateDisplayFilter('salary');
            this.displayAssociateCandidateSelectedFilter.rate = this._setSalaryAndRateDisplayFilter('rate');
        }
        else if (type === 'salary') {
            this.displayAssociateCandidateSelectedFilter.salary = this._setSalaryAndRateDisplayFilter('salary');
        }
        else {
            this.displayAssociateCandidateSelectedFilter.rate = this._setSalaryAndRateDisplayFilter('rate');
        }
        this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
        this.isDisplayRateFilterActive = this.matchedCandidatesContainer.searchObject.rate && this.matchedCandidatesContainer.searchObject.rate != "" ? true : false;
    };
    AssociateCandidatesController.prototype._setWorkAuthorizations = function () {
        var _this = this;
        this.selectedWorkAuthorizationList = this.workAuthorizationList.filter(function (work) { return _this.jobDetails.sponsorships.some(function (value) { return work.value === value; }); });
        if (this.noAdditionalDetails) {
            this.workAuthorizationList.forEach(function (workAuth) {
                if (workAuth.name == 'No Work Authorization') {
                    workAuth.ticked = true;
                }
            });
            var noWorkAuthorization = this.workAuthorizationList.filter(function (work) { return _this.jobDetails.sponsorships.some(function (value) { return work.name === 'No Work Authorization'; }); });
            this.selectedWorkAuthorizationList = noWorkAuthorization ? tslib_1.__spread(this.selectedWorkAuthorizationList, noWorkAuthorization) : this.selectedWorkAuthorizationList;
        }
        this.selectedWorkAuthorizationList.forEach(function (work) { return work.ticked = true; });
        this._setAssociateCandidateDisplayFilters('sponsorships');
    };
    AssociateCandidatesController.prototype._setPreferredJobType = function () {
        var _this = this;
        this.selectedJobTypeList = this.jobTypeList.filter(function (jobType) { return jobType.name === _this.jobDetails.jobType; });
        if (this.noAdditionalDetails) {
            this.jobTypeList.forEach(function (jobType) {
                if (jobType.name == 'No Pref. Job Type') {
                    jobType.ticked = true;
                }
            });
            var noPreferredJobType = this.jobTypeList.filter(function (jobType) { return jobType.name === 'No Pref. Job Type'; });
            this.selectedJobTypeList = noPreferredJobType ? tslib_1.__spread(this.selectedJobTypeList, noPreferredJobType) : this.selectedJobTypeList;
        }
        this.selectedJobTypeList.forEach(function (jobType) { return jobType.ticked = true; });
        this._setAssociateCandidateDisplayFilters('jobTypes');
    };
    AssociateCandidatesController.prototype._setSalaryAndRateDisplayFilter = function (type) {
        var salaryOrRateFilter = "";
        if (type === 'salary') {
            salaryOrRateFilter = this.matchedCandidatesContainer.searchObject.salary ?
                "" + (this.matchedCandidatesContainer.searchObject.salary.toString() + " " + this.matchedCandidatesContainer.searchObject.salaryCurrency + " " + this._setDisplayFilterSalaryOrRateDuration('salary') + this._setSalaryOrRateNotSpecified('salary')) : "";
        }
        else {
            salaryOrRateFilter = this.matchedCandidatesContainer.searchObject.rate ?
                "" + (this.matchedCandidatesContainer.searchObject.rate.toString() + " " + this.matchedCandidatesContainer.searchObject.rateCurrency + " " + this._setDisplayFilterSalaryOrRateDuration('rate') + this._setSalaryOrRateNotSpecified('rate')) : "";
        }
        return salaryOrRateFilter;
    };
    AssociateCandidatesController.prototype._setDisplayFilterSalaryOrRateDuration = function (type) {
        var _this = this;
        var durationOption = "";
        if (!this.salaryDurationOptions) {
            return durationOption;
        }
        if (type === 'salary') {
            var match = this.salaryDurationOptions.find(function (val) { return _this.matchedCandidatesContainer.searchObject.salaryDuration === val.value; });
            durationOption = match ? match.name : "";
        }
        else {
            var match = this.salaryDurationOptions.find(function (val) { return _this.matchedCandidatesContainer.searchObject.rateDuration === val.value; });
            durationOption = match ? match.name : "";
        }
        return durationOption;
    };
    AssociateCandidatesController.prototype.addToDisplayFilters = function (event) {
        switch (event) {
            case 'search':
                this.displayAssociateCandidateSelectedFilter.searchText = this.matchedCandidatesContainer.searchObject.searchText;
                break;
            default:
                break;
        }
        this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
    };
    AssociateCandidatesController.prototype._setSalaryOrRate = function (filter) {
        if (this.jobDetails.jobSalary) {
            filter.currency = this.jobDetails.jobSalary.currency;
            if (this.jobDetails.jobSalary.salaryDuration === 'PER_YEAR') {
                filter.salaryDuration = this.jobDetails.jobSalary.salaryDuration;
                filter.salary = this.jobDetails.jobSalary.maxSalary;
                var salaryDurationMatch = this.salaryDurationOptions && this.salaryDurationOptions.find(function (val) { return filter.salaryDuration === val.value; });
                this.displayAssociateCandidateSelectedFilter.salary = filter.salary && salaryDurationMatch ? "" + (filter.salary.toString() + " " + filter.currency + " " + salaryDurationMatch.name) : "";
            }
            else {
                filter.rateDuration = this.jobDetails.jobSalary.salaryDuration;
                filter.rate = this.jobDetails.jobSalary.maxSalary;
                var rateDurationMatch = this.salaryDurationOptions && this.salaryDurationOptions.find(function (val) { return filter.rateDuration === val.value; });
                this.displayAssociateCandidateSelectedFilter.rate = filter.rate && rateDurationMatch ? "" + (filter.rate.toString() + " " + filter.currency + " " + rateDurationMatch.name) : "";
            }
            if (this.associateCandidatesDefaultFilter.includeCandidatesWithNoAdditionalDetails) {
                if (filter.salary) {
                    this.displayAssociateCandidateSelectedFilter.salary = this.displayAssociateCandidateSelectedFilter.salary + " OR Salary = Not Specified";
                }
                if (filter.rate) {
                    this.displayAssociateCandidateSelectedFilter.rate = this.displayAssociateCandidateSelectedFilter.rate + " OR Rate = Not Specified";
                }
            }
        }
        this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
    };
    AssociateCandidatesController.prototype.checkPreferredJobType = function (jobType) {
        var isJobTypePresent;
        if (this.selectedJobTypeList && this.selectedJobTypeList.length > 0) {
            for (var i = 0; i < this.selectedJobTypeList.length; i++) {
                if (this.selectedJobTypeList[i].value === jobType) {
                    isJobTypePresent = true;
                    break;
                }
                else {
                    isJobTypePresent = false;
                }
            }
        }
        else {
            isJobTypePresent = false;
        }
        return isJobTypePresent;
    };
    AssociateCandidatesController.prototype.sortRequisitions = function (sortColumn, selectedSort, selectedSortDir) {
        this.isFiltersChanged = true;
        this.selectedSort = selectedSort;
        this.selectedSortDir = selectedSortDir;
        this.matchedCandidatesContainer.searchObject.column = "";
        this.matchedCandidatesContainer.searchObject.sortDirection = "";
        if (angular.isDefined(sortColumn) && sortColumn != "") {
            var array = sortColumn.split(" ");
            this.matchedCandidatesContainer.searchObject.column = array[0];
            this.matchedCandidatesContainer.searchObject.sortDirection = array[1];
        }
        this.displayAssociateCandidateSelectedFilter.selectedFilterSort = "";
        if (this.selectedSort != 'Please Select') {
            this.displayAssociateCandidateSelectedFilter.selectedFilterSort = this.selectedSort + " " + "(" + this.selectedSortDir + ")";
        }
        this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
    };
    AssociateCandidatesController.prototype.selectRemoveAll = function (label, type, doQueryFlag) {
        if (type == 'selectAll') {
            switch (label) {
                case 'workLocations':
                    this.selectedWorkLocations = tslib_1.__spread(this.workLocations);
                    this.onWorkLocationSelected();
                    break;
                case 'jobType':
                    this.selectedJobTypeList = tslib_1.__spread(this.jobTypeList);
                    this.onJobTypeSelected();
                    break;
                case 'jobSubTypes':
                    this.selectedJobTypeAdditionalList = tslib_1.__spread(this.jobTypeAdditionalList);
                    this.onAdditionalJobTypeSelected();
                    break;
                case 'sponsorships':
                    this.selectedWorkAuthorizationList = tslib_1.__spread(this.workAuthorizationList);
                    this.onWorkAuthorizationSelected();
                    break;
                default:
                //do nothing;
            }
        }
        else {
            switch (label) {
                case 'workLocations':
                    this.selectedWorkLocations = [];
                    this.onWorkLocationSelected();
                    break;
                case 'jobType':
                    this.selectedJobTypeList = [];
                    this.onJobTypeSelected();
                    break;
                case 'jobSubTypes':
                    this.selectedJobTypeAdditionalList = [];
                    this.onAdditionalJobTypeSelected();
                    break;
                case 'sponsorships':
                    this.selectedWorkAuthorizationList = [];
                    this.onWorkAuthorizationSelected();
                    break;
                default:
                //do nothing
            }
        }
    };
    AssociateCandidatesController.prototype.resetAssociateCandidatesFilters = function (type) {
        var _this = this;
        this.isFiltersChanged = true;
        this.isClearClicked = type === 'reset' ? false : true;
        if (this.matchedCandidatesContainer.searchByTextFlag) {
            this.matchedCandidatesContainer.searchObject.searchText = "";
            this.displayAssociateCandidateSelectedFilter.searchText = '';
            this.matchedCandidatesContainer.searchObject.requestSource = 'CONTACT';
            this.matchedCandidatesContainer.searchObject.includeCandidatesMatchingMandatoryCriteria = false;
            this.matchedCandidatesContainer.searchObject.withoutJobMatchScore = type === 'reset' ? true : false;
        }
        else if (!this.matchedCandidatesContainer.searchByTextFlag) {
            this.matchedCandidatesContainer.searchObject.numberOfDays = 0;
            this.matchedCandidatesContainer.topMatches = 0;
            this.matchedCandidatesContainer.searchObject.topMatches = this.matchedCandidatesContainer.topMatches;
            this.displayAssociateCandidateSelectedFilter.numberOfDays = '';
            this.displayAssociateCandidateSelectedFilter.topMatches = '';
            this.displayAssociateCandidateSelectedFilter.score = '';
            this.matchedCandidatesContainer.searchObject.includeCandidatesMatchingMandatoryCriteria = false;
            this.matchedCandidatesContainer.searchObject.requestSource = 'JOB_MATCH_SCORE';
            this.matchedCandidatesContainer.searchObject.withoutJobMatchScore = false;
        }
        this.displayAssociateCandidateSelectedFilter.workLocationIds = [];
        if (this.associateCandidatesDefaultFilterCopy.workLocationIds && this.associateCandidatesDefaultFilterCopy.workLocationIds.length > 0 && type === 'reset') {
            this.workLocations.forEach(function (workLocation) {
                if (_this.associateCandidatesDefaultFilterCopy.workLocationIds.includes(workLocation.id)) {
                    workLocation.ticked = true;
                    _this.displayAssociateCandidateSelectedFilter.workLocationIds.push(workLocation.name);
                }
                else {
                    workLocation.ticked = false;
                }
            });
        }
        else {
            this.workLocations.forEach(function (workLocation) { return workLocation.ticked = false; });
        }
        this.matchedCandidatesContainer.searchObject.workLocationIds = type === 'reset' ? this.associateCandidatesDefaultFilterCopy.workLocationIds : [];
        this.displayAssociateCandidateSelectedFilter.sponsorships = [];
        if (this.associateCandidatesDefaultFilterCopy.sponsorships && this.associateCandidatesDefaultFilterCopy.sponsorships.length && type === 'reset') {
            this.workAuthorizationList.forEach(function (work) {
                if (_this.associateCandidatesDefaultFilterCopy.sponsorships.includes(work.value)) {
                    _this.displayAssociateCandidateSelectedFilter.sponsorships.push(work.name);
                    work.ticked = true;
                }
                else {
                    work.ticked = false;
                }
            });
        }
        else {
            this.workAuthorizationList.forEach(function (work) { return work.ticked = false; });
        }
        this.matchedCandidatesContainer.searchObject.sponsorships = type === 'reset' ? this.associateCandidatesDefaultFilterCopy.sponsorships : [];
        this.displayAssociateCandidateSelectedFilter.jobTypes = [];
        if (this.associateCandidatesDefaultFilterCopy.jobTypes && this.associateCandidatesDefaultFilterCopy.jobTypes.length > 0 && type === 'reset') {
            this.jobTypeList.forEach(function (jobType) {
                if (_this.associateCandidatesDefaultFilterCopy.jobTypes.includes(jobType.value)) {
                    _this.displayAssociateCandidateSelectedFilter.jobTypes.push(jobType.name);
                    jobType.ticked = true;
                }
                else {
                    jobType.ticked = false;
                }
            });
        }
        else {
            this.jobTypeList.forEach(function (jobType) { return jobType.ticked = false; });
        }
        this.matchedCandidatesContainer.searchObject.jobTypes = type === 'reset' ? this.associateCandidatesDefaultFilterCopy.jobTypes : [];
        this.displayAssociateCandidateSelectedFilter.jobSubTypes = [];
        if (this.associateCandidatesDefaultFilterCopy.jobSubTypes && this.associateCandidatesDefaultFilterCopy.jobSubTypes.length > 0 && type === 'reset') {
            this.jobTypeAdditionalList.forEach(function (jobSubType) {
                if (_this.associateCandidatesDefaultFilterCopy.jobSubType.includes(jobSubType.value)) {
                    _this.displayAssociateCandidateSelectedFilter.jobSubTypes.push(jobSubType.name);
                    jobSubType.ticked = true;
                }
                else {
                    jobSubType.ticked = false;
                }
            });
        }
        else {
            this.jobTypeAdditionalList.forEach(function (jobSubType) { return jobSubType.ticked = false; });
        }
        this.matchedCandidatesContainer.searchObject.jobSubTypes = type === 'reset' ? this.associateCandidatesDefaultFilterCopy.jobSubTypes : [];
        this.matchedCandidatesContainer.searchObject.includeCandidatesWithNoAdditionalDetails = type === 'reset' ? this.associateCandidatesDefaultFilterCopy.includeCandidatesWithNoAdditionalDetails : false;
        // Set Salary and Rate
        this.matchedCandidatesContainer.searchObject.salary = type === 'reset' ? this.associateCandidatesDefaultFilterCopy.salary : null;
        this.matchedCandidatesContainer.searchObject.rate = type === 'reset' ? this.associateCandidatesDefaultFilterCopy.rate : null;
        this.matchedCandidatesContainer.searchObject.salaryDuration = this.associateCandidatesDefaultFilterCopy.salaryDuration;
        this.matchedCandidatesContainer.searchObject.rateDuration = this.associateCandidatesDefaultFilterCopy.rateDuration;
        this.matchedCandidatesContainer.searchObject.salaryCurrency = this.associateCandidatesDefaultFilterCopy.salaryCurrency;
        this.matchedCandidatesContainer.searchObject.rateCurrency = this.associateCandidatesDefaultFilterCopy.rateCurrency;
        this.displayAssociateCandidateSelectedFilter.salary = type === 'reset' ? this._setSalaryAndRateDisplayFilter('salary') : "";
        this.displayAssociateCandidateSelectedFilter.rate = type === 'reset' ? this._setSalaryAndRateDisplayFilter('rate') : "";
        // Set Scroll
        this.matchedCandidatesContainer.searchObject.minimumScore = this.jobDetails.fourDotFiveIntelligenceScore;
        this.matchedCandidatesContainer.searchObject.maximumScore = 100;
        this._createMatchScoreSlider();
        // Set Sort
        if (type === 'clear') {
            this.sortRequisitions('', 'Please Select', '');
            this.matchedCandidatesContainer.searchObject.column = "Score";
            this.matchedCandidatesContainer.searchObject.sortDirection = "Desc";
        }
        else {
            if (this.matchedCandidatesContainer.searchByTextFlag) {
                this.sortRequisitions('Score Desc', 'Score', 'Desc');
                this.matchedCandidatesContainer.searchObject.column = "Score";
                this.matchedCandidatesContainer.searchObject.sortDirection = "Desc";
            }
            else if (!this.matchedCandidatesContainer.searchByTextFlag) {
                this.sortRequisitions('Score Desc', 'Score', 'Desc');
                this.matchedCandidatesContainer.searchObject.column = "Score";
                this.matchedCandidatesContainer.searchObject.sortDirection = "Desc";
            }
        }
        this.isDisplayRateFilterActive = this.matchedCandidatesContainer.searchObject.rate && this.matchedCandidatesContainer.searchObject.rate != "" ? true : false;
    };
    AssociateCandidatesController.prototype.onGlobalFilterChange = function (event) {
        this.isFiltersChanged = true;
        if (!this.isFilterOpen) {
            $("#associate-search-panel").animate({
                height: 'toggle'
            });
            this.isFilterOpen = !this.isFilterOpen;
        }
    };
    AssociateCandidatesController.prototype.displaySelectedFilterToggle = function () {
        this.showCandidateDisplaySelectedFilterPanel = true;
        if (this.displayCandidateFilterFlag) {
            $("#display-Associate-candidate-selected-filter-panel").animate({
                height: 'toggle'
            });
            this.displayAssociateCandidateSelectedFilter.showCandidateDisplayFilterIcon = !this.displayAssociateCandidateSelectedFilter.showCandidateDisplayFilterIcon;
        }
        // Set Display Filter Collapse and Expand Panel
        this._setShowCandidateDisplayFilterIcon(this.displayAssociateCandidateSelectedFilter.showCandidateDisplayFilterIcon);
    };
    AssociateCandidatesController.prototype._setObjectVariableName = function (currentObject) {
        var selectedFilterVariableNameObj = {
            searchText: "Search", numberOfDays: "Last Modified", topMatches: "Top Matches", workLocationIds: "Work Locations",
            jobTypes: "Job Type", jobSubTypes: "Additional Contract Types", sponsorships: "Work Authorizations", salary: "Salary",
            rate: "Rate", selectedFilterSort: "Sort By", score: "Job Match Score"
        };
        for (var key in selectedFilterVariableNameObj) {
            if (selectedFilterVariableNameObj.hasOwnProperty(key)) {
                var obj = selectedFilterVariableNameObj[key];
                if (key == currentObject.variable) {
                    this.displaySelectedFilterObj.variable = obj;
                }
            }
        }
    };
    AssociateCandidatesController.prototype.setCandidateDisplayedFilterItemSelected = function (itemsSelected) {
        var _this = this;
        this.emptyCandidateSelectedFilter = false;
        for (var key in itemsSelected) {
            if (itemsSelected.hasOwnProperty(key)) {
                var obj = itemsSelected[key];
                if (obj.length > 0) {
                    this.displayCandidateFilterFlag = true;
                    this.displaySelectedFilterObj = {};
                    if (this.candidateFilterItemsSelected.length !== 0) {
                        this.candidateFilterItemsSelected.forEach(function (filterItem) {
                            if (filterItem.filter == key) {
                                if (filterItem.setSelectedFilterLimit == 5) {
                                    _this.displaySelectedFilterObj = { filter: key, variable: key, value: obj, setSelectedFilterLimit: 5, expandSelectedFilter: false };
                                }
                                else {
                                    _this.displaySelectedFilterObj = { filter: key, variable: key, value: obj, setSelectedFilterLimit: obj.length, expandSelectedFilter: filterItem.expandSelectedFilter };
                                }
                            }
                        });
                    }
                    if (this.candidateFilterItemsSelected.length == 0 || Object.keys(this.displaySelectedFilterObj).length == 0) {
                        this.displaySelectedFilterObj = { filter: key, variable: key, value: obj, setSelectedFilterLimit: 5, expandSelectedFilter: false };
                    }
                    this._setObjectVariableName(this.displaySelectedFilterObj);
                    if (this.candidateFilterItemsSelected.length > 0) {
                        this.candidateFilterItemsSelected = this.candidateFilterItemsSelected.filter(function (item) { return item.variable !== _this.displaySelectedFilterObj.variable; });
                    }
                    this.candidateFilterItemsSelected.push(this.displaySelectedFilterObj);
                }
                else {
                    if (this.candidateFilterItemsSelected.length > 0) {
                        this.candidateFilterItemsSelected = this.candidateFilterItemsSelected.filter(function (item) { return item.filter !== key; });
                    }
                }
            }
        }
        if (this.candidateFilterItemsSelected.length === 0) {
            if (!this.matchedCandidatesContainer.isFilterOn) {
                this.displayCandidateFilterFlag = false;
                this._setShowCandidateDisplayFilterIcon(true);
            }
            else {
                this.emptyCandidateSelectedFilter = true;
            }
        }
    };
    AssociateCandidatesController.prototype._setShowCandidateDisplayFilterIcon = function (boolean) {
        if (this.displayAssociateCandidateSelectedFilter.showCandidateDisplayFilterIcon !== boolean) {
            this.displayAssociateCandidateSelectedFilter.showCandidateDisplayFilterIcon = boolean;
        }
    };
    AssociateCandidatesController.prototype.isFilterValueArray = function (value) {
        if (Array.isArray(value)) {
            return true;
        }
        else {
            return false;
        }
    };
    AssociateCandidatesController.prototype._deleteSelectedItem = function (currentObject, deletedItem) {
        var _this = this;
        switch (currentObject.variable) {
            case 'searchText':
                this.matchedCandidatesContainer.searchObject.searchText = '';
                this.displayAssociateCandidateSelectedFilter.searchText = '';
                this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
                break;
            case 'score':
                this.matchedCandidatesContainer.searchObject.minimumScore = this.jobDetails.fourDotFiveIntelligenceScore;
                this.matchedCandidatesContainer.searchObject.maximumScore = 100;
                this._createMatchScoreSlider();
                this.displayAssociateCandidateSelectedFilter.score = '';
                this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
                break;
            case 'numberOfDays':
                this.matchedCandidatesContainer.searchObject.numberOfDays = 0;
                this.displayAssociateCandidateSelectedFilter.numberOfDays = '';
                this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
                break;
            case 'topMatches':
                this.matchedCandidatesContainer.searchObject.topMatches = 0;
                this.matchedCandidatesContainer.topMatches = 0;
                this.displayAssociateCandidateSelectedFilter.topMatches = '';
                this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
                break;
            case 'workLocationIds':
                this.workLocations.forEach(function (workLocation, index) {
                    if (workLocation.name === deletedItem) {
                        workLocation.ticked = false;
                        _this.selectedWorkLocations = _this.selectedWorkLocations.filter(function (item) { return item.name !== deletedItem; });
                    }
                });
                this.onWorkLocationSelected();
                break;
            case 'jobTypes':
                this.jobTypeList.forEach(function (jobType, index) {
                    if (jobType.name === deletedItem) {
                        jobType.ticked = false;
                        _this.selectedJobTypeList = _this.selectedJobTypeList.filter(function (item) { return item.name !== deletedItem; });
                    }
                });
                this.onJobTypeSelected();
                break;
            case 'jobSubTypes':
                this.jobTypeAdditionalList.forEach(function (additionalJobType, index) {
                    if (additionalJobType.name === deletedItem) {
                        additionalJobType.ticked = false;
                        _this.selectedJobTypeAdditionalList = _this.selectedJobTypeAdditionalList.filter(function (item) { return item.name !== deletedItem; });
                    }
                });
                this.onAdditionalJobTypeSelected();
                break;
            case 'sponsorships':
                this.workAuthorizationList.forEach(function (sponsorship, index) {
                    if (sponsorship.value === deletedItem) {
                        sponsorship.ticked = false;
                        _this.selectedWorkAuthorizationList = _this.selectedWorkAuthorizationList.filter(function (item) { return item.value !== deletedItem; });
                    }
                    else if (sponsorship.name === deletedItem) {
                        sponsorship.ticked = false;
                        _this.selectedWorkAuthorizationList = _this.selectedWorkAuthorizationList.filter(function (item) { return item.name !== deletedItem; });
                    }
                });
                this.onWorkAuthorizationSelected();
                break;
            case 'salary':
                this.matchedCandidatesContainer.searchObject.salary = null;
                this.displayAssociateCandidateSelectedFilter.salary = "";
                this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
                break;
            case 'rate':
                this.matchedCandidatesContainer.searchObject.rate = null;
                this.displayAssociateCandidateSelectedFilter.rate = "";
                this.isDisplayRateFilterActive = false;
                this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
                break;
            case 'selectedFilterSort':
                this.sortRequisitions('', 'Please Select', '');
                break;
            default:
                break;
        }
    };
    AssociateCandidatesController.prototype.deleteSelectedFilterItem = function (deletedItem) {
        this._setOpenGlobalFilter();
        for (var key in this.displayAssociateCandidateSelectedFilter) {
            if (this.displayAssociateCandidateSelectedFilter.hasOwnProperty(key)) {
                var obj = this.displayAssociateCandidateSelectedFilter[key];
                if (Array.isArray(obj)) {
                    if (obj.includes(deletedItem)) {
                        this.deleteSelectedFilter = {};
                        this.deleteSelectedFilter = { variable: key, value: obj };
                        this._deleteSelectedItem(this.deleteSelectedFilter, deletedItem);
                    }
                }
                else {
                    if (obj == deletedItem) {
                        this.deleteSelectedFilter = {};
                        this.deleteSelectedFilter = { variable: key, value: obj };
                        this._deleteSelectedItem(this.deleteSelectedFilter, deletedItem);
                    }
                }
            }
        }
    };
    AssociateCandidatesController.prototype._setOpenGlobalFilter = function () {
        if (!this.showFiltersPanel) {
            $("#search-panel").animate({
                height: 'toggle'
            });
            this.showFiltersPanel = true;
        }
    };
    AssociateCandidatesController.prototype._setResumeOptions = function () {
        var _this = this;
        var companyIdToCheckAUploadResumeAccess;
        // // include clientOrBuId only for staffing company client
        if (this.isAssociateCandidateForCorp) {
            this.clientOrBuId = null;
        }
        if (!_.isUndefined(this.corporateId) && this.corporateId !== "") {
            companyIdToCheckAUploadResumeAccess = this.corporateId;
        }
        else {
            companyIdToCheckAUploadResumeAccess = this.$rootScope.userDetails.company.companyId;
        }
        // //Check for resume options only for external reqs and shared reqs
        if ((this.isSharedRequisition && !_.isUndefined(this.corporateId) && this.corporateId !== "") || (!this.isAssociateCandidateForCorp)) {
            this.companyService.hasAccessToUploadResume(companyIdToCheckAUploadResumeAccess, this.clientOrBuId, function (data) {
                _this.isUploadResumeOnlyEnabled = data;
            }, function (error) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
        else {
            this.isUploadResumeOnlyEnabled = false;
        }
    };
    AssociateCandidatesController.prototype.checkIfSalaryOrRateDefined = function (type) {
        var isNoPrefJobTypeSelected = this.selectedJobTypeList.some(function (item) {
            return item && item.value === 'NO_PREF_JOBTYPE';
        });
        if (type === 'salary') {
            if (_.isUndefined(this.matchedCandidatesContainer.searchObject.salary) || this.matchedCandidatesContainer.searchObject.salary < 0) {
                this.matchedCandidatesContainer.searchObject.salary = 1;
            }
            this._setAssociateCandidateDisplayFilters('salary');
            if (this.matchedCandidatesContainer.searchObject.includeCandidatesWithNoAdditionalDetails ||
                (!this.matchedCandidatesContainer.searchObject.includeCandidatesWithNoAdditionalDetails && isNoPrefJobTypeSelected)) {
                this._setAssociateCandidateDisplayFilters('rate');
            }
        }
        else if (type === 'rate') {
            if (_.isUndefined(this.matchedCandidatesContainer.searchObject.rate) || this.matchedCandidatesContainer.searchObject.rate < 0) {
                this.matchedCandidatesContainer.searchObject.rate = 1;
            }
            this._setAssociateCandidateDisplayFilters('rate');
            if (this.matchedCandidatesContainer.searchObject.includeCandidatesWithNoAdditionalDetails ||
                (!this.matchedCandidatesContainer.searchObject.includeCandidatesWithNoAdditionalDetails && isNoPrefJobTypeSelected)) {
                this._setAssociateCandidateDisplayFilters('salary');
            }
        }
    };
    AssociateCandidatesController.prototype._checkIfCandidatesInformationMatch = function (candidate) {
        var candidateInformationMatch = false;
        if (candidate.candidateAdditionalDetailsCard &&
            (this.associateCandidatesDefaultFilterCopy.jobTypes.length === 0 || candidate.candidateAdditionalDetailsCard.preferredJobIcon === 'GREEN') &&
            ((!this.associateCandidatesDefaultFilterCopy.salary && !this.associateCandidatesDefaultFilterCopy.rate) || candidate.candidateAdditionalDetailsCard.salaryIcon === 'GREEN') &&
            (this.associateCandidatesDefaultFilterCopy.sponsorships.length === 0 || candidate.candidateAdditionalDetailsCard.sponsorshipIcon === 'GREEN') &&
            (this.associateCandidatesDefaultFilterCopy.workLocationIds.length === 0 || (candidate.workLocationsMatchStatus && candidate.workLocationsMatchStatus === 'match'))) {
            candidateInformationMatch = true;
        }
        return candidateInformationMatch;
    };
    AssociateCandidatesController.prototype._setMessageCandidateInformation = function (candidate) {
        var messageOptions = [];
        if (candidate.candidateAdditionalDetailsCard) {
            if (this.associateCandidatesDefaultFilterCopy.jobTypes.length > 0 && candidate.candidateAdditionalDetailsCard.preferredJobIcon != 'GREEN') {
                messageOptions.push("Preferred job types");
            }
            if ((this.associateCandidatesDefaultFilterCopy.salary || this.associateCandidatesDefaultFilterCopy.rate) && candidate.candidateAdditionalDetailsCard.salaryIcon != 'GREEN') {
                messageOptions.push("Salary");
            }
            if (this.associateCandidatesDefaultFilterCopy.sponsorships.length > 0 && candidate.candidateAdditionalDetailsCard.sponsorshipIcon != 'GREEN') {
                messageOptions.push("Sponsorships");
            }
            if (this.associateCandidatesDefaultFilterCopy.workLocationIds.length > 0 && (!candidate.workLocationsMatchStatus || candidate.workLocationsMatchStatus != 'match')) {
                messageOptions.push("Work locations");
            }
        }
        if (messageOptions.length > 0) {
            return messageOptions.toString().split(',').join(', ');
        }
        else {
            return "";
        }
    };
    AssociateCandidatesController.prototype.addToSelectedCandidates = function (candidate) {
        var _this = this;
        if (!this._checkIfCandidatesInformationMatch(candidate) || (this.resumeRequiredForWorkflow && !candidate.resumeExist)) {
            var title = "Alert";
            var candidateName = candidate.name ? "<span class=\"font-bold\">" + candidate.name + "</span>" : "Candidate's";
            var message = '';
            if (this._checkIfCandidatesInformationMatch(candidate) && (this.resumeRequiredForWorkflow && !candidate.resumeExist)) {
                message = "<div>\n                    " + this.setIsResumeRequiredForWorkflowMessage(candidate) + "\n                    <p class=\"mb-0\">Add it Anyway?</p>\n                </div>";
            }
            else if (!this._checkIfCandidatesInformationMatch(candidate) && (this.resumeRequiredForWorkflow && !candidate.resumeExist)) {
                message = "<div>\n                    " + this.setIsResumeRequiredForWorkflowMessage(candidate) + "\n                    <p>" + candidateName + " '<span class=\"text-primary\">" + this._setMessageCandidateInformation(candidate) + "</span>' entry does not match with the Requisition.</p>\n                    <p class=\"mb-0\">Add it Anyway?</p>\n                </div>";
            }
            else {
                message = "<div>\n                    <p>" + candidateName + " '<span class=\"text-primary\">" + this._setMessageCandidateInformation(candidate) + "</span>' entry does not match with the Requisition.</p>\n                    <p class=\"mb-0\">Add it Anyway?</p>\n                </div>";
            }
            this.alertsAndNotificationsService.showConfirm(title, message, "warning", false, function () {
                _this.selectCandidate(candidate);
                _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            }, function () {
                //do nothing
                _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            });
        }
        else {
            this.selectCandidate(candidate);
        }
    };
    AssociateCandidatesController.prototype.selectCandidate = function (candidate) {
        if (candidate.showOverride) {
            this.matchedCandidatesContainer.selectedCandidates.push(candidate);
            this._confirmOverrideSuspension(candidate);
        }
        else if (candidate.allowManualMatch) {
            candidate.selectedFlag = true;
            this.matchedCandidatesContainer.selectedCandidates.push(candidate);
        }
        else {
            this._showBootboxWarning(candidate.reasonForNoManualMatch);
        }
        this.$scope.$emit('candidateList:filtered');
    };
    AssociateCandidatesController.prototype._confirmOverrideSuspension = function (candidate) {
        var _this = this;
        var message = candidate.reasonForNoManualMatch;
        var allowOverride = candidate.allowOverride;
        var suspendedMonths = 0;
        var releaseDate = '';
        var releasedJobDetails = {};
        var type = "release";
        var candidateId = candidate.id;
        var candidateName = candidate.name;
        if (candidate.overrideFor == "JOB_LEFT") {
            suspendedMonths = candidate.jobLeftDetail.numberOfMonthsToWait;
            releaseDate = this.$filter('fourdotfiveDateFormat')(candidate.jobLeftDetail.leftAt);
            releasedJobDetails = candidate.jobLeftDetail;
            type = "jobLeft";
        }
        else {
            suspendedMonths = candidate.releasedCandidateDetail.numberOfMonthsToWait;
            releaseDate = this.$filter('fourdotfiveDateFormat')(candidate.releasedCandidateDetail.releasedAt);
            releasedJobDetails = candidate.releasedCandidateDetail;
        }
        // if(type == 'release') {
        //     message = "Candidate '<span class='emerald'>" + candidate.name + "</span>' cannot apply for any position as it is within '<span class='emerald'>" + suspendedMonths + "</span>' month(s) of candidate's previous release. ";
        //     message = message + "Candidate was previously released on '<span class='emerald'>" + this.$filter('fourdotfiveDateFormat')(releaseDate) + "</span>' from the role '<span class='emerald'>" + releasedJobDetails.role + "</span>' ";
        //     message = message + "with Requisition Number '<span class='emerald'>" + releasedJobDetails.requisitionNumber + "</span>'."
        // } else {
        //     message = "Candidate <span class='emerald'>'" + candidate.name + "'</span> cannot apply for any position as it is within '<span class='emerald'>" + suspendedMonths + "</span>' month(s) of leaving previous job. ";
        //     message = message + "Candidate left previous job on '<span class='emerald'>" + this.$filter('fourdotfiveDateFormat')(releaseDate) + "</span>' from the role '<span class='emerald'>" + releasedJobDetails.role + "</span>' ";
        //     message = message + "with Requisition Number '<span class='emerald'>" + releasedJobDetails.requisitionNumber + "</span>'."
        // }
        // message = message + "<br>Would you like to override?";
        if (allowOverride) {
            bootbox.confirm({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Confirm</strong></div>",
                message: message,
                className: "zIndex1060",
                backdrop: true,
                onEscape: false,
                buttons: {
                    confirm: {
                        label: 'Override',
                        className: 'btn-info'
                    },
                    cancel: {
                        label: 'Cancel',
                        className: 'btn-danger'
                    }
                },
                callback: function (result) {
                    var vm = _this;
                    if (result) {
                        _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                        $(".modal").addClass("associate-candidate-modal");
                        _this.$timeout(function () {
                            _this.warningModal = _this.$uibModal.open({
                                animation: true,
                                ariaLabelledBy: 'modal-title',
                                ariaDescribedBy: 'modal-body',
                                backdrop: 'static',
                                windowClass: 'four-dot-five-modal-medium',
                                template: AssociatesCandidateActionsModalTemplate.default,
                                backdrop: false,
                                controller: ['$uibModalInstance', 'candidateId', 'candidateName', 'suspendedMonths', 'releaseDate', 'allowOverride', 'releasedJobDetails', 'type', function ($uibModalInstance, candidateId, candidateName, suspendedMonths, releaseDate, allowOverride, releasedJobDetails, type) {
                                        var ctrl = this;
                                        ctrl.candidateId = candidateId;
                                        ctrl.candidateName = candidateName;
                                        ctrl.suspendedMonths = suspendedMonths;
                                        ctrl.releaseDate = releaseDate;
                                        ctrl.allowOverride = allowOverride;
                                        ctrl.recruiterDetails = new OverrideNoteDetail(ctrl.candidateId);
                                        ctrl.releasedJobDetails = releasedJobDetails;
                                        ctrl.type = type;
                                        ctrl.modalTitle = "Override";
                                        ctrl.saveCallback = function () {
                                            if (type === "release") {
                                                candidate.releasedCandidateDetail.releasedAt = null;
                                            }
                                            else {
                                                candidate.jobLeftDetail.leftAt = null;
                                            }
                                            vm.createJobMatchesObject.overrideNoteDetails.push(ctrl.recruiterDetails);
                                            $uibModalInstance.close('cancel');
                                        };
                                        ctrl.closeModal = function () {
                                            vm.removeCandidate(candidate);
                                            $uibModalInstance.close('cancel');
                                        };
                                    }],
                                controllerAs: 'associateCandidatesActionModal',
                                size: 'md',
                                resolve: {
                                    candidateId: function () {
                                        return candidateId;
                                    },
                                    candidateName: function () {
                                        return candidateName;
                                    },
                                    suspendedMonths: function () {
                                        return suspendedMonths;
                                    },
                                    releaseDate: function () {
                                        return releaseDate;
                                    },
                                    allowOverride: function () {
                                        return allowOverride;
                                    },
                                    releasedJobDetails: function () {
                                        return releasedJobDetails;
                                    },
                                    type: function () {
                                        return type;
                                    }
                                }
                            });
                        }, 300);
                    }
                    else {
                        vm.removeCandidate(candidate);
                        vm.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                    }
                }
            });
        }
        else {
            var displayHtmlText = "";
            if (type == 'release') {
                displayHtmlText = "Candidate '<span class='emerald'>" + candidateName + "</span>' cannot apply for any position as it is within '<span class='emerald'>" + suspendedMonths + "</span>' month(s) of candidate's previous release. ";
                displayHtmlText = displayHtmlText + "Candidate was previously released on '<span class='emerald'>" + this.$filter('fourdotfiveDateFormat')(releaseDate) + "</span>' from the role '<span class='emerald'>" + releasedJobDetails.role + "</span>' ";
                displayHtmlText = displayHtmlText + "with Requisition Number '<span class='emerald'>" + releasedJobDetails.requisitionNumber + "</span>'.";
            }
            else {
                displayHtmlText = "Candidate <span class='emerald'>'" + candidateName + "'</span> cannot apply for any position as it is within '<span class='emerald'>" + suspendedMonths + "</span>' month(s) of leaving previous job. ";
                displayHtmlText = displayHtmlText + "Candidate left previous job on '<span class='emerald'>" + this.$filter('fourdotfiveDateFormat')(releaseDate) + "</span>' from the role '<span class='emerald'>" + releasedJobDetails.role + "</span>' ";
                displayHtmlText = displayHtmlText + "with Requisition Number '<span class='emerald'>" + releasedJobDetails.requisitionNumber + "</span>'.";
            }
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Cannot add candidate</strong></div>",
                message: displayHtmlText,
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                },
                callback: function () {
                    _this.removeCandidate(candidate);
                    _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                }
            });
        }
    };
    AssociateCandidatesController.prototype._showBootboxWarning = function (message) {
        var _this = this;
        bootbox.alert({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Cannot associate candidate</strong></div>",
            message: message,
            className: "zIndex1060",
            backdrop: true,
            onEscape: false,
            buttons: {
                ok: {
                    label: 'Ok',
                    className: 'btn-info'
                }
            }, callback: function () {
                _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            }
        });
    };
    AssociateCandidatesController.prototype.removeCandidate = function (candidate) {
        _.remove(this.matchedCandidatesContainer.selectedCandidates, {
            id: candidate.id
        });
        _.remove(this.createJobMatchesObject.overrideNoteDetail, {
            candidateId: candidate.id
        });
        var index = _.findIndex(this.matchedCandidatesContainer.candidates, {
            id: candidate.id
        });
        if (index >= 0) {
            this.matchedCandidatesContainer.candidates[index].selectedFlag = false;
        }
        this.matchedCandidatesContainer.selectAllDoneFlag = false;
    };
    AssociateCandidatesController.prototype._createSlimScroll = function () {
        this.$timeout(function () {
            $('.associate-candidates-matched-candidates-div').slimScroll({
                start: 'top',
                alwaysVisible: false,
                railVisible: false,
                wheelStep: 20,
                allowPageScroll: true,
                height: '350px'
            });
            $('.associate-candidates-selected-candidates-div').slimScroll({
                start: 'top',
                alwaysVisible: false,
                railVisible: false,
                wheelStep: 20,
                allowPageScroll: true,
                height: '380px'
            });
        }, 100);
    };
    AssociateCandidatesController.prototype._getBasicCandidateInfo = function (candidate) {
        var basicCandidateInfo = {};
        basicCandidateInfo.name = candidate.contact.firstname + ' ' + candidate.contact.lastname;
        basicCandidateInfo.id = candidate.id;
        basicCandidateInfo.email = candidate.contact.email;
        basicCandidateInfo.mobilePhone = candidate.contact.mobilephone;
        basicCandidateInfo.workPhone = candidate.contact.workphone;
        basicCandidateInfo.matchScore = candidate.matchScore;
        basicCandidateInfo.candidateStatus = candidate.candidateStatus;
        if (!_.isNull(candidate.lastModifiedDate)) {
            basicCandidateInfo.lastModifiedDate = new Date(candidate.lastModifiedDate);
        }
        basicCandidateInfo.candidateJobMatches = [];
        basicCandidateInfo.jobMatchesPopoverPosition = 'bottom';
        if (_.isNull(basicCandidateInfo.matchScore)) {
            basicCandidateInfo.matchScore = 'N/A';
        }
        else {
            basicCandidateInfo.intelligenceScorePassFlag = false;
            if (basicCandidateInfo.matchScore >= this.jobDetails.fourDotFiveIntelligenceScore) {
                basicCandidateInfo.intelligenceScorePassFlag = true;
            }
            // round the match score to the lower integer value.
            basicCandidateInfo.matchScore = Math.floor(parseFloat(basicCandidateInfo.matchScore));
        }
        basicCandidateInfo.allowManualMatch = candidate.allowManualMatch;
        basicCandidateInfo.showOverride = candidate.showOverride;
        basicCandidateInfo.allowOverride = candidate.allowOverride;
        basicCandidateInfo.reasonForNoManualMatch = candidate.reasonForNoManualMatch;
        basicCandidateInfo.releaseDate = candidate.releaseDate;
        basicCandidateInfo.suspendedMonths = candidate.suspendedMonths;
        basicCandidateInfo.releasedCandidateDetail = candidate.releasedCandidateDetail;
        basicCandidateInfo.jobLeftDetail = candidate.jobLeftDetail;
        basicCandidateInfo.overrideFor = candidate.overrideFor;
        basicCandidateInfo.resumeExist = candidate.resumeExist;
        basicCandidateInfo.matchingMandatoryCriteria = candidate.matchingMandatoryCriteria;
        return basicCandidateInfo;
    };
    AssociateCandidatesController.prototype.getCandidateJobMatches = function (candidateId, successCallback) {
        var candidateJobMatches = [];
        var jobMatchesObject = new JobMatchQueryFilter();
        jobMatchesObject.candidateId = candidateId;
        jobMatchesObject.userId = this.$rootScope.userDetails.id;
        jobMatchesObject.companyId = this.$rootScope.userDetails.company.companyId;
        jobMatchesObject.top5Flag = false;
        jobMatchesObject.candidateType = "OWN_CANDIDATES";
        jobMatchesObject.searchText = '';
        jobMatchesObject.vendorIds = [];
        this.candidateService.getCandidateJobMatches(jobMatchesObject, 1, 250, function (data) {
            angular.forEach(data, function (val, key) {
                val.jobMatchDate = new Date(val.jobMatchDate);
                candidateJobMatches.push(val);
            });
            if (successCallback) {
                successCallback(candidateJobMatches);
            }
        }, function (error) {
            console.log('candidate job matches get error - ', error);
            // do nothing.
        });
    };
    AssociateCandidatesController.prototype.selectAllCandidates = function () {
        var _this = this;
        this.matchedCandidatesContainer.selectAllDoneFlag = true;
        var tempSearchObject = angular.copy(this.matchedCandidatesContainer.searchObject);
        if (this.matchedCandidatesContainer.searchByTextFlag) {
            delete tempSearchObject.minimumScore;
            delete tempSearchObject.maximumScore;
        }
        else {
            delete tempSearchObject.searchText;
        }
        if (tempSearchObject.numberOfDays == 0) {
            delete tempSearchObject.numberOfDays;
        }
        tempSearchObject.page = 1;
        tempSearchObject.size = this.matchedCandidatesContainer.totalCandidateCount;
        var selectingAllCandidatesDialog = bootbox.dialog({
            message: '<p class="text-center">Selecting ' + this.matchedCandidatesContainer.totalCandidateCount + ' Candidates <i class="fa fa-spinner fa-spin"></i></p>',
            closeButton: false
        });
        tempSearchObject.loggedInUserId = this.$rootScope.userDetails.id;
        this.jobService.findMatchingCandidatesForJob(tempSearchObject, function (data) {
            selectingAllCandidatesDialog.modal('hide');
            _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            angular.forEach(data.candidateMinimumInfoDtos, function (val, key) {
                var basicCandidateInfo = _this._getBasicCandidateInfo(val);
                var indexInSelectedCandidates = _.findIndex(_this.matchedCandidatesContainer.selectedCandidates, {
                    id: basicCandidateInfo.id
                });
                // if the candidate is not already in the selected candidates list, select the candidate
                if (indexInSelectedCandidates < 0) {
                    _this.selectCandidate(basicCandidateInfo);
                }
                var indexInVisibleCandidates = _.findIndex(_this.matchedCandidatesContainer.candidates, {
                    id: basicCandidateInfo.id
                });
                // if the candidate is already in the visible candidates list, make the candidate selected
                if (indexInVisibleCandidates >= 0) {
                    _this.matchedCandidatesContainer.candidates[indexInVisibleCandidates].selectedFlag = true;
                }
            });
        }, function (error) {
            selectingAllCandidatesDialog.modal('hide');
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    AssociateCandidatesController.prototype.deselectAllCandidates = function () {
        var _this = this;
        this.matchedCandidatesContainer.selectAllDoneFlag = false;
        var tempSearchObject = angular.copy(this.matchedCandidatesContainer.searchObject);
        if (this.matchedCandidatesContainer.searchByTextFlag) {
            delete tempSearchObject.minimumScore;
            delete tempSearchObject.maximumScore;
        }
        else {
            delete tempSearchObject.searchText;
        }
        if (tempSearchObject.numberOfDays == 0) {
            delete tempSearchObject.numberOfDays;
        }
        tempSearchObject.page = 1;
        tempSearchObject.size = this.matchedCandidatesContainer.totalCandidateCount;
        var selectingAllCandidatesDialog = bootbox.dialog({
            message: '<p class="text-center">Deselecting ' + this.matchedCandidatesContainer.totalCandidateCount + ' Candidates <i class="fa fa-spinner fa-spin"></i></p>',
            closeButton: false
        });
        tempSearchObject.loggedInUserId = this.$rootScope.userDetails.id;
        this.jobService.findMatchingCandidatesForJob(tempSearchObject, function (data) {
            selectingAllCandidatesDialog.modal('hide');
            _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            angular.forEach(data.candidateMinimumInfoDtos, function (val, key) {
                var basicCandidateInfo = _this._getBasicCandidateInfo(val);
                var indexInSelectedCandidates = _.findIndex(_this.matchedCandidatesContainer.selectedCandidates, {
                    id: basicCandidateInfo.id
                });
                // if the candidate is in the selected candidates list, remove the candidate
                if (indexInSelectedCandidates >= 0) {
                    _this.removeCandidate(basicCandidateInfo);
                }
            });
        }, function (error) {
            selectingAllCandidatesDialog.modal('hide');
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    AssociateCandidatesController.prototype.deselectAllSelectedCandidates = function () {
        var _this = this;
        angular.forEach(this.matchedCandidatesContainer.selectedCandidates, function (val, key) {
            var index = _.findIndex(_this.matchedCandidatesContainer.candidates, {
                id: val.id
            });
            if (index >= 0) {
                _this.matchedCandidatesContainer.candidates[index].selectedFlag = false;
            }
        });
        this.matchedCandidatesContainer.selectAllDoneFlag = false;
        this.matchedCandidatesContainer.selectedCandidates = [];
    };
    AssociateCandidatesController.prototype.onTopMatchFilterMatchesFilterChange = function () {
        var _this = this;
        this.onGlobalFilterChange();
        this.matchedCandidatesContainer.searchObject.topMatches = this.matchedCandidatesContainer.topMatches;
        if (this.matchedCandidatesContainer.searchObject.topMatches == 0) {
            this.displayAssociateCandidateSelectedFilter.topMatches = '';
        }
        else {
            this.displayAssociateCandidateSelectedFilter.topMatches = this.topMatchesOptions.filter(function (topMatch) { return topMatch.value == _this.matchedCandidatesContainer.searchObject.topMatches; })[0].text;
        }
        this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
    };
    AssociateCandidatesController.prototype.onLastModifiedFilterChange = function () {
        var _this = this;
        this.onGlobalFilterChange();
        if (this.matchedCandidatesContainer.searchObject.numberOfDays == 0) {
            this.displayAssociateCandidateSelectedFilter.numberOfDays = '';
        }
        else {
            this.displayAssociateCandidateSelectedFilter.numberOfDays = this.lastModifiedOptions.filter(function (lastModified) { return lastModified.value == _this.matchedCandidatesContainer.searchObject.numberOfDays; })[0].text;
        }
        this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
    };
    AssociateCandidatesController.prototype.searchTypeChanged = function () {
        if (!this.isFilterOpen) {
            this.onGlobalFilterChange();
        }
        if (!this.matchedCandidatesContainer.searchByTextFlag) {
            // reset the 'number of days' filter to zero
            this.matchedCandidatesContainer.searchObject.withoutJobMatchScore = false;
            this.matchedCandidatesContainer.searchObject.includeCandidatesMatchingMandatoryCriteria = false;
            this.matchedCandidatesContainer.searchObject.includeCandidatesWithNoAdditionalDetails = this.isClearClicked ? false : true;
            this.matchedCandidatesContainer.searchObject.requestSource = 'JOB_MATCH_SCORE';
            this.matchedCandidatesContainer.searchObject.numberOfDays = 0;
            //top matches reset to zero
            this.matchedCandidatesContainer.topMatches = 0;
            this.matchedCandidatesContainer.searchObject.topMatches = this.matchedCandidatesContainer.topMatches;
            this.displayAssociateCandidateSelectedFilter.searchText = '';
            this.displayAssociateCandidateSelectedFilter.score = this._setJobMatchScoreDisplayFilter(this.matchedCandidatesContainer.searchObject.minimumScore, this.matchedCandidatesContainer.searchObject.maximumScore);
            this.displayAssociateCandidateSelectedFilter.salary = this._setSalaryAndRateDisplayFilter('salary');
            this.displayAssociateCandidateSelectedFilter.rate = this._setSalaryAndRateDisplayFilter('rate');
            this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
            this.sortRequisitions('Score Desc', 'Score', 'Desc');
        }
        else {
            this.matchedCandidatesContainer.searchObject.requestSource = 'CONTACT';
            this.matchedCandidatesContainer.searchObject.withoutJobMatchScore = this.isClearClicked ? false : true;
            this.matchedCandidatesContainer.searchObject.includeCandidatesMatchingMandatoryCriteria = false;
            this.matchedCandidatesContainer.searchObject.includeCandidatesWithNoAdditionalDetails = this.isClearClicked ? false : true;
            delete this.matchedCandidatesContainer.searchObject.topMatches;
            this.displayAssociateCandidateSelectedFilter.numberOfDays = '';
            this.displayAssociateCandidateSelectedFilter.topMatches = '';
            this.displayAssociateCandidateSelectedFilter.score = '';
            this.displayAssociateCandidateSelectedFilter.searchText = this.matchedCandidatesContainer.searchObject.searchText;
            this.displayAssociateCandidateSelectedFilter.salary = this._setSalaryAndRateDisplayFilter('salary');
            this.displayAssociateCandidateSelectedFilter.rate = this._setSalaryAndRateDisplayFilter('rate');
            this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
            this.sortRequisitions('Score Desc', 'Score', 'Desc');
        }
        this.onNoAdditionalChange();
        this.searchForMatchingCandidates();
    };
    AssociateCandidatesController.prototype._createMatchScoreSlider = function () {
        var _this = this;
        this.minimumScoreSliderPadding = this.jobDetails.fourDotFiveIntelligenceScore < 65 ? this.jobDetails.fourDotFiveIntelligenceScore : (this.jobDetails.fourDotFiveIntelligenceScore - 4);
        var sliderId = '#matchScoreSlider';
        $(sliderId).empty();
        $(sliderId).noUiSlider({
            range: [0.00, 100.00],
            start: [this.jobDetails.fourDotFiveIntelligenceScore, 100],
            margin: 1.00,
            handles: 2,
            connect: true,
            step: 1,
            slide: function () {
                var val = $(sliderId).val();
                _this.matchedCandidatesContainer.searchObject.minimumScore = parseInt(val[0]);
                _this.matchedCandidatesContainer.searchObject.maximumScore = parseInt(val[1]);
                _this.minimumScoreSliderPadding = _this.matchedCandidatesContainer.searchObject.minimumScore < 65 ? _this.matchedCandidatesContainer.searchObject.minimumScore : (_this.matchedCandidatesContainer.searchObject.minimumScore - 4);
                _this.maximumScoreSliderPadding = _this.matchedCandidatesContainer.searchObject.maximumScore < 65 ? _this.matchedCandidatesContainer.searchObject.maximumScore : (_this.matchedCandidatesContainer.searchObject.maximumScore - 4);
                //avoid overlapping of min and max slider values
                if (_this.matchedCandidatesContainer.searchObject.minimumScore > 9 && _this.matchedCandidatesContainer.searchObject.maximumScore - _this.matchedCandidatesContainer.searchObject.minimumScore >= 0 && _this.matchedCandidatesContainer.searchObject.maximumScore - _this.matchedCandidatesContainer.searchObject.minimumScore <= 8) {
                    _this.maximumScoreSliderTopPosition = 80;
                }
                else {
                    _this.maximumScoreSliderTopPosition = 65;
                }
                $('#matchScoreSliderDisplayMinValue').addClass('job-match-score-slider-highlight-score');
                $('#matchScoreSliderDisplayMaxValue').addClass('job-match-score-slider-highlight-score');
                _this.$scope.$apply();
                _this.isFiltersChanged = true;
                _this.displayAssociateCandidateSelectedFilter.score = _this._setJobMatchScoreDisplayFilter(_this.matchedCandidatesContainer.searchObject.minimumScore, _this.matchedCandidatesContainer.searchObject.maximumScore);
                _this.setCandidateDisplayedFilterItemSelected(_this.displayAssociateCandidateSelectedFilter);
            },
            set: function () {
                var val = $(sliderId).val();
                _this.matchedCandidatesContainer.searchObject.minimumScore = parseInt(val[0]);
                _this.matchedCandidatesContainer.searchObject.maximumScore = parseInt(val[1]);
                $('#matchScoreSliderDisplayMinValue').removeClass('job-match-score-slider-highlight-score');
                $('#matchScoreSliderDisplayMaxValue').removeClass('job-match-score-slider-highlight-score');
                _this.onGlobalFilterChange();
            }
        });
        $(".noUi-origin.noUi-origin-upper").css('background', '#eee');
    };
    AssociateCandidatesController.prototype.searchForMatchingCandidates = function () {
        var _this = this;
        this.isFiltersChanged = false;
        this.isDisplayRateFilterActive = this.matchedCandidatesContainer.searchObject.rate && this.matchedCandidatesContainer.searchObject.rate != "" ? true : false;
        if (this.candidateFilterItemsSelected.length === 0) {
            this.displayCandidateFilterFlag = false;
            this.displayAssociateCandidateSelectedFilter.showCandidateDisplayFilterIcon = true;
        }
        // clear any existing query requests
        // check for an existing promise and see if it has not been fulfilled yet. If it has not been fulfilled yet, cancel the promise.
        if (this.matchedCandidatesContainer && this.matchedCandidatesContainer.currentPromise && this.matchedCandidatesContainer.currentPromise.$$state) {
            if (this.matchedCandidatesContainer.currentPromise.$$state.status == 0) {
                this.genericService.cancelRequest(this.matchedCandidatesContainer.currentPromise);
            }
        }
        // reset the initial value of candidates exist flag to true
        this.matchedCandidatesContainer.candidatesExistFlag = true;
        // reset the page number to 1 as this is a new query
        this.matchedCandidatesContainer.searchObject.page = 1;
        // clear select all candidates selection
        this.selectAllCandidatesFlag = false;
        // clear the existing candidates
        this.matchedCandidatesContainer.candidates = [];
        this.matchedCandidatesContainer.totalCandidateCount = null;
        this.matchedCandidatesContainer.selectAllDoneFlag = false;
        this.matchedCandidatesContainer.disableInfiniteScroll = false;
        // wait for the cancelled promise to be fulfilled.
        this.$timeout(function () {
            _this.isFiltersChanged = false;
            _this.matchedCandidatesContainer.getNext();
        }, 200);
    };
    AssociateCandidatesController.prototype.associateCandidates = function () {
        var _this = this;
        var candidateIds = [];
        angular.forEach(this.matchedCandidatesContainer.selectedCandidates, function (val, key) {
            _this.createJobMatchesObject.candidateIds.push(val.id);
            candidateIds.push({
                id: val.id,
                candidateType: val.candidateJobMatches.length > 0 ? val.candidateJobMatches[0].candidateType : 'OWN_CANDIDATES'
            });
        });
        this.savingFlag = true;
        var associatingDialog = bootbox.dialog({
            message: '<p class="text-center">Associating Candidates <i class="fa fa-spinner fa-spin"></i></p>',
            closeButton: false
        });
        this._associateCandidates(this.matchedCandidatesContainer.selectedCandidates, function () {
            associatingDialog.modal('hide');
        });
    };
    AssociateCandidatesController.prototype._associateCandidates = function (allSelectedCandidates, successCallback) {
        var _this = this;
        var selectedCandidates = tslib_1.__spread(allSelectedCandidates);
        this.jobMatchService.createJobMatches(this.createJobMatchesObject, function (data) {
            _this.savingFlag = false;
            if (successCallback) {
                successCallback();
            }
            _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            _this.alertsAndNotificationsService.showAlertWithCallBack("Success!", "Candidate(s) associated successfully.", "success", function () {
                if (_this.saveCallback) {
                    _this.saveCallback();
                }
                _this.$timeout(function () {
                    _this.sendOutreachEmailToCandidates(selectedCandidates);
                }, 500);
            });
        }, function (error) {
            _this.savingFlag = false;
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    AssociateCandidatesController.prototype.jobCompare = function (candidate) {
        var actionObject = new JobMatchAction("Candidate Job Comparison", "CANDIDATE_JOB_COMPARE", true, null);
        candidate.jobMatchJobId = this.jobId;
        this.jobMatchActionsService.performAction('associateCandidates', actionObject, candidate, function () {
        }, function () {
        });
    };
    AssociateCandidatesController.prototype.onNoAdditionalChange = function () {
        if (this.matchedCandidatesContainer.searchObject.includeCandidatesWithNoAdditionalDetails) {
            var selectDefault = function (list, name) {
                var item = list.find(function (i) { return i.name === name; });
                return item ? tslib_1.__assign({}, item, { ticked: true }) : [];
            };
            if (this.selectedWorkLocations.length === 0 || !this.selectedWorkLocations.some(function (item) { return item && item.name === 'No Work Location'; })) {
                // Work Locations
                this.workLocations.forEach(function (workLocation) {
                    if (workLocation.name == 'No Work Location') {
                        workLocation.ticked = true;
                    }
                });
                this.selectedWorkLocations.push(selectDefault(this.workLocations, 'No Work Location'));
                this.onWorkLocationSelected();
            }
            if (this.selectedJobTypeList.length === 0 || !this.selectedJobTypeList.some(function (item) { return item && item.name === 'No Pref. Job Type'; })) {
                // Job Types
                this.jobTypeList.forEach(function (jobType) {
                    if (jobType.name == 'No Pref. Job Type') {
                        jobType.ticked = true;
                    }
                });
                this.selectedJobTypeList.push(selectDefault(this.jobTypeList, 'No Pref. Job Type'));
                this.onJobTypeSelected();
            }
            if (this.selectedWorkAuthorizationList.length === 0 || !this.selectedWorkAuthorizationList.some(function (item) { return item && item.name === 'No Work Authorization'; })) {
                // Work Authorizations
                this.workAuthorizationList.forEach(function (workAuth) {
                    if (workAuth.name == 'No Work Authorization') {
                        workAuth.ticked = true;
                    }
                });
                this.selectedWorkAuthorizationList.push(selectDefault(this.workAuthorizationList, 'No Work Authorization'));
                this.onWorkAuthorizationSelected();
            }
        }
        else {
            this.selectedWorkLocations = this.selectedWorkLocations.filter(function (workLocation) { return workLocation.id != 'NO_WORK_LOCATION'; });
            this.workLocations.forEach(function (workLocation) {
                if (workLocation.name == 'No Work Location') {
                    workLocation.ticked = false;
                }
            });
            this.onWorkLocationSelected();
            this.selectedJobTypeList = this.selectedJobTypeList.filter(function (workLocation) { return workLocation.name != 'No Pref. Job Type'; });
            this.jobTypeList.forEach(function (jobType) {
                if (jobType.name == 'No Pref. Job Type') {
                    jobType.ticked = false;
                }
            });
            this.onJobTypeSelected();
            this.selectedWorkAuthorizationList = this.selectedWorkAuthorizationList.filter(function (workLocation) { return workLocation.name != 'No Work Authorization'; });
            this.workAuthorizationList.forEach(function (workAuth) {
                if (workAuth.name == 'No Work Authorization') {
                    workAuth.ticked = false;
                }
            });
            this.onWorkAuthorizationSelected();
        }
        this.displayAssociateCandidateSelectedFilter.salary = this._setSalaryAndRateDisplayFilter('salary');
        this.displayAssociateCandidateSelectedFilter.rate = this._setSalaryAndRateDisplayFilter('rate');
        this.setCandidateDisplayedFilterItemSelected(this.displayAssociateCandidateSelectedFilter);
    };
    AssociateCandidatesController.prototype.setIsResumeRequiredForWorkflowMessage = function (candidate) {
        if (this.resumeRequiredForWorkflow && !candidate.resumeExist) {
            return "<p class=\"font-bold text-danger\">Since this requisition requires candidates with resumes, after association, any candidate without resumes must have their resumes uploaded in the workflow.</p>";
        }
        else {
            return '';
        }
    };
    AssociateCandidatesController.prototype._setSalaryOrRateNotSpecified = function (type) {
        var isNoPrefJobTypeSelected = this.selectedJobTypeList.some(function (item) {
            return item && item.value === 'NO_PREF_JOBTYPE';
        });
        if (this.matchedCandidatesContainer.searchObject.includeCandidatesWithNoAdditionalDetails ||
            (!this.matchedCandidatesContainer.searchObject.includeCandidatesWithNoAdditionalDetails && isNoPrefJobTypeSelected)) {
            this.isDisplayRateFilterActive = true;
            if (type === 'rate' && this.matchedCandidatesContainer.searchObject.rate) {
                return " OR Rate = Not Specified";
            }
            else if (type === 'salary' && this.matchedCandidatesContainer.searchObject.salary) {
                return " OR Salary = Not Specified";
            }
        }
        else {
            return "";
        }
    };
    AssociateCandidatesController.prototype.sendOutreachEmailToCandidates = function (selectedCandidates) {
        var _this = this;
        var windowClass = 'four-dot-five-modal-small';
        var validCandidatesToSendOutreachEmail = [];
        var notValidCandidatesToSendOutreachEmail = [];
        var selectedJobMatchesForOutreach = [];
        var isSingleCandidateSelected = false;
        var candidateId = '';
        var candidateType = '';
        var companyId = this.$rootScope.userDetails.company.companyId;
        var userId = this.$rootScope.userDetails.id;
        selectedCandidates.map(function (candidate, index) {
            var tempObject = {};
            tempObject.jobMatchId = "";
            tempObject.candidateId = candidate.id;
            tempObject.workflowStepName = "";
            tempObject.candidateName = candidate.name;
            tempObject.message = "";
            tempObject.selected = true;
            tempObject.candidateType = candidate.vendorName ? 'VENDOR_CANDIDATES' : 'OWN_CANDIDATES';
            if (!candidate.email) {
                tempObject.message = "Email ID not available.";
                notValidCandidatesToSendOutreachEmail.push(tempObject);
            }
            else {
                validCandidatesToSendOutreachEmail.push(tempObject);
                if (selectedCandidates.length == 1) {
                    selectedJobMatchesForOutreach = tslib_1.__spread(selectedCandidates);
                }
            }
        });
        isSingleCandidateSelected = selectedCandidates.length == 1 && validCandidatesToSendOutreachEmail.length == 1 ? true : false;
        if (isSingleCandidateSelected) {
            selectedJobMatchesForOutreach[0].candidateJobMatches.forEach(function (jobMatch) {
                jobMatch.requisitionNumber = jobMatch.requisitionNumber;
                jobMatch.jobTitle = jobMatch.title;
                jobMatch.companyName = jobMatch.company;
                jobMatch.jobLocationText = _this.jobMatchService.setJobLocationText(jobMatch.jobLocation);
                jobMatch.jobId = jobMatch.jobId;
                selectedJobMatchesForOutreach[0].candidateId = selectedJobMatchesForOutreach[0].id;
                candidateType = candidateType != '' ? candidateType : jobMatch.candidateType;
            });
            windowClass = 'four-dot-five-modal-large';
            candidateId = selectedJobMatchesForOutreach[0].id;
            selectedJobMatchesForOutreach[0].activeJobId = this.jobId;
        }
        var label = isSingleCandidateSelected ? "Send outreach to Candidate <b>'" + selectedJobMatchesForOutreach[0].name + "'</b>" : "Send outreach to Candidates";
        var vm = this;
        $(".modal").addClass("associate-candidate-modal");
        this.sendOutreachEmailModal = this.$uibModal.open({
            animation: false,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: CandidateSendOutreachEmailModal.default,
            backdrop: 'static',
            windowTopClass: windowClass,
            controller: ['$uibModalInstance', 'label', 'validCandidatesToSendOutreachEmail', 'notValidCandidatesToSendOutreachEmail', 'isSingleCandidateSelected', 'companyId', 'userId', 'candidateId', 'clientOrBUId', 'candidateType', 'selectedJobMatchesForOutreach', 'context',
                function ($uibModalInstance, label, validCandidatesToSendOutreachEmail, notValidCandidatesToSendOutreachEmail, isSingleCandidateSelected, companyId, userId, candidateId, clientOrBUId, candidateType, selectedJobMatchesForOutreach, context) {
                    var ctrl = this;
                    ctrl.label = label;
                    ctrl.validCandidatesToSendOutreachEmail = validCandidatesToSendOutreachEmail;
                    ctrl.notValidCandidatesToSendOutreachEmail = notValidCandidatesToSendOutreachEmail;
                    ctrl.isSingleCandidateSelected = isSingleCandidateSelected;
                    ctrl.companyId = companyId;
                    ctrl.userId = userId;
                    ctrl.candidateId = candidateId;
                    ctrl.clientOrBUId = clientOrBUId;
                    ctrl.candidateType = candidateType;
                    ctrl.selectedJobMatchesForOutreach = selectedJobMatchesForOutreach;
                    ctrl.context = context;
                    ctrl.closeModal = function () {
                        $uibModalInstance.close('cancel');
                    };
                    ctrl.saveCallback = function () {
                        if (isSingleCandidateSelected) {
                            ctrl.closeModal();
                            vm.resetCandidateJobMatches();
                        }
                        else {
                            var passedCandidateList_1 = [];
                            if (ctrl.validCandidatesToSendOutreachEmail.length > 0) {
                                ctrl.validCandidatesToSendOutreachEmail.map(function (candidate) {
                                    if (candidate.selected) {
                                        passedCandidateList_1.push({
                                            id: candidate.candidateId,
                                            candidateType: candidate.candidateType,
                                            source: 'CANDIDATE_CARD',
                                            jobIds: [vm.jobId],
                                            jobMatchId: ""
                                        });
                                    }
                                });
                            }
                            if (passedCandidateList_1.length > 0) {
                                var outreachObject = {
                                    candidates: passedCandidateList_1,
                                    userId: userId,
                                    companyId: companyId,
                                    clientOrBuId: vm.clientOrBuId
                                };
                                vm.candidateService.sendOutreachEmail(outreachObject, function (data) {
                                    vm.alertsAndNotificationsService.showBannerMessage(data.message, 'success');
                                    ctrl.closeModal();
                                }, function (error) {
                                    ctrl.closeModal();
                                    vm.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                                });
                            }
                            else {
                                var title = "No candidates selected";
                                var message = "Please select atleast one candidate.";
                                vm.alertsAndNotificationsService.showAlert(title, message, "warning");
                            }
                        }
                    };
                    ctrl.cancelCallback = function () {
                        ctrl.closeModal();
                    };
                }],
            controllerAs: 'sendOutreachEmailModal',
            size: 'lg',
            resolve: {
                validCandidatesToSendOutreachEmail: function () {
                    return validCandidatesToSendOutreachEmail;
                },
                notValidCandidatesToSendOutreachEmail: function () {
                    return notValidCandidatesToSendOutreachEmail;
                },
                label: function () {
                    return label;
                },
                isSingleCandidateSelected: function () {
                    return isSingleCandidateSelected;
                },
                companyId: function () {
                    return companyId;
                },
                userId: function () {
                    return userId;
                },
                candidateId: function () {
                    return candidateId;
                },
                clientOrBUId: function () {
                    return vm.clientOrBuId;
                },
                candidateType: function () {
                    return candidateType;
                },
                selectedJobMatchesForOutreach: function () {
                    return selectedJobMatchesForOutreach;
                },
                context: function () {
                    return 'associateCandidates';
                }
            }
        });
    };
    return AssociateCandidatesController;
}());
AssociateCandidatesController.$inject = ['$rootScope', '$scope', '$timeout', '$uibModal', '$filter', 'jobService', 'jobMatchActionsService', 'candidateService', 'jobMatchService', 'companyService', 'genericService', 'modalService', 'debounceService', 'alertsAndNotificationsService', 'requisitionService', 'MESSAGECONSTANTS'];
// import * as TEMPLATE from './associate-candidates.html';
import * as TEMPLATE from 'raw-loader!./associate-candidates.html';
export var AssociateCandidatesComponent = {
    selector: 'associateCandidates',
    component: {
        bindings: {
            jobId: '@',
            clientOrBuName: '@',
            corporateId: '@',
            clientOrBuId: '@',
            isSharedRequisition: '<',
            resumeRequiredForWorkflow: '<',
            saveCallback: '&'
        },
        controller: AssociateCandidatesController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/associateCandidates/associate-candidates.html'
    }
};
//# sourceMappingURL=associate-candidates.component.js.map